interface Config {
  affiliateManagerAppUrl: string
  blogsAppUrl: string
  builderPreviewUrl?: string
  calendarAppURL: string
  calendarBetaPreviewUrl: string
  conversationsAppUrl: string
  crmLocationAppURL: string
  crmOpportunitiesAppURL: string
  emailBuilderApp: string
  emailHomeAppUrl: string
  emailPreviewAppUrl: string
  formBetaPreviewUrl: string
  formBuilderAppURL: string
  funnelBetaPreviewUrl: string
  funnelBuilderAppURL: string
  isvAppUrl: string
  mobileAppCustomiserAppUrl: string
  newEmailHomeBetaUrl: string
  newEmailPreviewBetaUrl: string
  newOnboardingFrontend: string
  paymentsAppUrl: string
  proposalBuilderAppUrl: string
  proposalTemplateBuilderAppUrl: string
  proposalBuilderPreviewUrl: string
  prospect: {
    frontendUrl: string
  }
  settingsAppUrl: string
  supportPortalUrl: string
  surveyBetaPreviewUrl: string
  templateLibraryAppUrl: string
  widgetUrl: string
  workflowAppURL: string
}

const override: boolean = process.env.VUE_APP_DB_OVERRIDE === 'true'

const config: { [key: string]: Config } = {
  development: {
    affiliateManagerAppUrl: 'https://staging-affiliate-manager.leadconnectorhq.com',
    blogsAppUrl: 'https://ghl-blogs-staging.leadconnectorhq.com',
    builderPreviewUrl: 'https://funnel-preview-dot-highlevel-staging.appspot.com',
    calendarAppURL: process.env.VUE_APP_CALENDAR_APP_URL || 'https://staging-client-app-calendars.leadconnectorhq.com',
    calendarBetaPreviewUrl: 'https://beta-labs-dot-funnel-preview-dot-highlevel-staging.appspot.com',
    conversationsAppUrl: 'https://staging-client-app-crm-conversations.leadconnectorhq.com',
    crmLocationAppURL:
      process.env.VUE_APP_CRM_LOCATIONS_APP_URL || 'https://staging-crm-apps-rollup.leadconnectorhq.com',
    crmOpportunitiesAppURL:
      process.env.VUE_APP_CRM_OPPORTUNITIES_APP_URL || 'https://staging-client-app-crm-opportunities.web.app/',
    emailBuilderApp: 'https://hl-email-builder.web.app',
    emailHomeAppUrl: 'https://hl-email-home-staging.leadconnectorhq.com',
    emailPreviewAppUrl: 'https://hl-email-preview.leadconnectorhq.com',
    formBetaPreviewUrl: 'https://beta-labs-dot-funnel-preview-dot-highlevel-staging.appspot.com',
    formBuilderAppURL: 'https://ghl-form-survey-builder-staging.leadconnectorhq.com',
    funnelBetaPreviewUrl: 'https://beta-labs-dot-funnel-preview-dot-highlevel-staging.appspot.com',
    funnelBuilderAppURL: 'https://page-builder-staging.leadconnectorhq.com',
    isvAppUrl: 'https://ghl-isv-app.leadconnectorhq.com',
    mobileAppCustomiserAppUrl: 'https://staging.mobile-whitelabel-customizer.leadconnectorhq.com',
    newEmailHomeBetaUrl: 'https://hl-email-home-staging.leadconnectorhq.com',
    newEmailPreviewBetaUrl: 'https://hl-email-preview.leadconnectorhq.com',
    newOnboardingFrontend: 'https://staging.onboarding.gohighlevel.com',
    paymentsAppUrl: 'https://app-payments-staging.leadconnectorhq.com',
    proposalBuilderAppUrl: 'https://staging-leadgen-apps-proposal-builder.leadconnectorhq.com',
    proposalTemplateBuilderAppUrl: 'https://staging-leadgen-apps-template-builder.leadconnectorhq.com',
    proposalBuilderPreviewUrl: 'https://staging.sendlink.co',
    prospect: {
      frontendUrl: 'https://staging.analyzemy.business',
    },
    settingsAppUrl: 'https://staging-client-app-crm-settings.leadconnectorhq.com',
    supportPortalUrl: 'https://staging.support.leadconnectorhq.com/',
    surveyBetaPreviewUrl: 'https://beta-labs-dot-funnel-preview-dot-highlevel-staging.appspot.com',
    templateLibraryAppUrl: 'https://staging-template-library.leadconnectorhq.com',
    widgetUrl: 'https://funnel-preview-dot-highlevel-staging.uc.r.appspot.com',
    workflowAppURL: 'https://hl-workflow.leadconnectorhq.com',
  },
  staging: {
    affiliateManagerAppUrl: 'https://staging-affiliate-manager.leadconnectorhq.com',
    blogsAppUrl: 'https://ghl-blogs-staging.leadconnectorhq.com',
    builderPreviewUrl: 'https://funnel-preview-dot-highlevel-staging.appspot.com',
    calendarAppURL: process.env.VUE_APP_CALENDAR_APP_URL || 'https://staging-client-app-calendars.leadconnectorhq.com',
    calendarBetaPreviewUrl: 'https://beta-labs-dot-funnel-preview-dot-highlevel-staging.appspot.com',
    conversationsAppUrl: 'https://staging-client-app-crm-conversations.leadconnectorhq.com',
    crmLocationAppURL:
      process.env.VUE_APP_CRM_LOCATIONS_APP_URL || 'https://staging-crm-apps-rollup.leadconnectorhq.com',
    crmOpportunitiesAppURL:
      process.env.VUE_APP_CRM_OPPORTUNITIES_APP_URL || 'https://staging-client-app-crm-opportunities.web.app/',
    emailBuilderApp: 'https://hl-email-builder.web.app',
    emailHomeAppUrl: 'https://hl-email-home-staging.leadconnectorhq.com',
    emailPreviewAppUrl: 'https://hl-email-preview.leadconnectorhq.com',
    formBetaPreviewUrl: 'https://beta-labs-dot-funnel-preview-dot-highlevel-staging.appspot.com',
    formBuilderAppURL: 'https://ghl-form-survey-builder-staging.leadconnectorhq.com',
    funnelBetaPreviewUrl: 'https://beta-labs-dot-funnel-preview-dot-highlevel-staging.appspot.com',
    funnelBuilderAppURL: 'https://page-builder-staging.leadconnectorhq.com',
    isvAppUrl: 'https://ghl-isv-app.leadconnectorhq.com',
    mobileAppCustomiserAppUrl: 'https://staging.mobile-whitelabel-customizer.leadconnectorhq.com',
    newEmailHomeBetaUrl: 'https://hl-email-home-staging.leadconnectorhq.com',
    newEmailPreviewBetaUrl: 'https://hl-email-preview.leadconnectorhq.com',
    newOnboardingFrontend: 'https://staging.onboarding.gohighlevel.com',
    paymentsAppUrl: 'https://app-payments-staging.leadconnectorhq.com',
    proposalBuilderAppUrl: 'https://staging-leadgen-apps-proposal-builder.leadconnectorhq.com',
    proposalTemplateBuilderAppUrl: 'https://staging-leadgen-apps-template-builder.leadconnectorhq.com',
    proposalBuilderPreviewUrl: 'https://staging.sendlink.co',
    prospect: {
      frontendUrl: 'https://staging.analyzemy.business',
    },
    settingsAppUrl: 'https://staging-client-app-crm-settings.leadconnectorhq.com',
    supportPortalUrl: 'https://staging.support.leadconnectorhq.com/',
    surveyBetaPreviewUrl: 'https://beta-labs-dot-funnel-preview-dot-highlevel-staging.appspot.com',
    templateLibraryAppUrl: 'https://staging-template-library.leadconnectorhq.com',
    widgetUrl: 'https://funnel-preview-dot-highlevel-staging.uc.r.appspot.com',
    workflowAppURL: 'https://hl-workflow.leadconnectorhq.com',
  },
  interop: {
    affiliateManagerAppUrl: 'https://interop-affiliate-manager.leadconnectorhq.com',
    blogsAppUrl: 'https://ghl-blogs-staging.leadconnectorhq.com',
    builderPreviewUrl: 'https://funnel-preview-dot-highlevel-staging.appspot.com',
    calendarAppURL: process.env.VUE_APP_CALENDAR_APP_URL || 'https://interop-client-app-calendars.leadconnectorhq.com',
    calendarBetaPreviewUrl: 'https://beta-labs-dot-funnel-preview-dot-highlevel-staging.appspot.com',
    conversationsAppUrl: 'https://staging-client-app-crm-conversations.leadconnectorhq.com',
    crmLocationAppURL:
      process.env.VUE_APP_CRM_LOCATIONS_APP_URL || 'https://interop-crm-apps-rollup.leadconnectorhq.com',
    crmOpportunitiesAppURL:
      process.env.VUE_APP_CRM_OPPORTUNITIES_APP_URL || 'https://staging-client-app-crm-opportunities.web.app/',
    emailBuilderApp: 'https://hl-email-builder.web.app',
    emailHomeAppUrl: 'https://leadgen-emails-home-interop.leadconnectorhq.com',
    emailPreviewAppUrl: 'https://hl-email-preview.leadconnectorhq.com',
    formBetaPreviewUrl: 'https://beta-labs-dot-funnel-preview-dot-highlevel-staging.appspot.com',
    formBuilderAppURL: 'https://interop-form-survey-builder.leadconnectorhq.com',
    funnelBetaPreviewUrl: 'https://beta-labs-dot-funnel-preview-dot-highlevel-staging.appspot.com',
    funnelBuilderAppURL: 'https://interop-page-builder.leadconnectorhq.com',
    isvAppUrl: 'https://ghl-isv-app-interop.leadconnectorhq.com',
    mobileAppCustomiserAppUrl: 'https://staging.mobile-whitelabel-customizer.leadconnectorhq.com',
    newEmailHomeBetaUrl: 'https://leadgen-emails-home-interop.leadconnectorhq.com',
    newEmailPreviewBetaUrl: 'https://hl-email-preview.leadconnectorhq.com',
    newOnboardingFrontend: 'https://staging.onboarding.gohighlevel.com',
    paymentsAppUrl: 'https://app-payments-staging.leadconnectorhq.com',
    proposalBuilderAppUrl: 'https://interop-leadgen-proposal-builder.leadconnectorhq.com',
    proposalTemplateBuilderAppUrl: 'https://interop-proposal-templates-builder.leadconnectorhq.com',
    proposalBuilderPreviewUrl: 'https://interop.sendlink.co',
    prospect: {
      frontendUrl: 'https://interop.analyzemy.business',
    },
    settingsAppUrl: 'https://interop-client-app-crm-settings.leadconnectorhq.com',
    supportPortalUrl: 'https://ghl-support-portal.leadconnectorhq.com/',
    surveyBetaPreviewUrl: 'https://beta-labs-dot-funnel-preview-dot-highlevel-staging.appspot.com',
    templateLibraryAppUrl: 'https://staging-template-library.leadconnectorhq.com',
    widgetUrl: 'https://funnel-preview-dot-highlevel-staging.uc.r.appspot.com',
    workflowAppURL: 'https://interop-client-app-automation-workflows.leadconnectorhq.com',
  },
  beta: {
    affiliateManagerAppUrl: 'https://beta-affiliate-manager.leadconnectorhq.com',
    blogsAppUrl: 'https://ghl-blogs-beta.leadconnectorhq.com',
    calendarAppURL: 'https://beta-client-app-calendars.leadconnectorhq.com',
    calendarBetaPreviewUrl: 'https://beta-widget.leadconnectorhq.com', // used production url
    conversationsAppUrl: 'https://client-app-crm-conversations.leadconnectorhq.com',
    crmLocationAppURL: 'https://beta-crm-apps-rollup.leadconnectorhq.com',
    crmOpportunitiesAppURL: 'https://client-app-crm-opportunities.leadconnectorhq.com/',
    emailBuilderApp: 'https://email-builder-beta.web.app',
    emailHomeAppUrl: 'https://email-home-beta.leadconnectorhq.com',
    emailPreviewAppUrl: 'https://email-preview-beta.leadconnectorhq.com',
    formBetaPreviewUrl: 'https://beta-widget.leadconnectorhq.com',
    formBuilderAppURL: 'https://beta-leadgen-apps-form-survey-builder.leadconnectorhq.com',
    funnelBetaPreviewUrl: 'https://beta-widget.leadconnectorhq.com',
    funnelBuilderAppURL: 'https://beta-page-builder.leadconnectorhq.com',
    isvAppUrl: 'https://ghl-isv-app-beta.leadconnectorhq.com',
    mobileAppCustomiserAppUrl: 'https://mobile-whitelabel-customizer.leadconnectorhq.com',
    newEmailHomeBetaUrl: 'https://email-home-beta.leadconnectorhq.com',
    newEmailPreviewBetaUrl: 'https://email-preview-beta.leadconnectorhq.com',
    newOnboardingFrontend: 'https://ghl-onboarding.leadconnectorhq.com',
    paymentsAppUrl: 'https://app-payments-beta.leadconnectorhq.com',
    proposalBuilderAppUrl: 'https://beta-leadgen-apps-proposal-builder.leadconnectorhq.com',
    proposalTemplateBuilderAppUrl: 'https://beta-leadgen-apps-template-builder.leadconnectorhq.com',
    proposalBuilderPreviewUrl: 'https://beta.sendlink.co',
    prospect: {
      frontendUrl: 'https://beta.analyzemy.business',
    },
    settingsAppUrl: 'https://client-app-crm-settings-beta.leadconnectorhq.com',
    supportPortalUrl: 'https://support.leadconnectorhq.com/',
    surveyBetaPreviewUrl: 'https://beta-widget.leadconnectorhq.com',
    templateLibraryAppUrl: 'https://beta-template-library.leadconnectorhq.com',
    widgetUrl: 'https://beta-dot-funnel-preview-dot-highlevel-backend.appspot.com',
    workflowAppURL: 'https://beta-client-app-automation-workflows.leadconnectorhq.com',
  },
  production: {
    affiliateManagerAppUrl: 'https://client-app-affiliate-manager.leadconnectorhq.com',
    blogsAppUrl: 'https://ghl-blogs-prod.leadconnectorhq.com',
    calendarAppURL: 'https://calendar-app.leadconnectorhq.com',
    calendarBetaPreviewUrl: 'https://beta-widget.leadconnectorhq.com',
    conversationsAppUrl: 'https://client-app-crm-conversations.leadconnectorhq.com',
    crmLocationAppURL: 'https://client-app-crm-locations.leadconnectorhq.com',
    crmOpportunitiesAppURL: 'https://client-app-crm-opportunities.leadconnectorhq.com/',
    emailBuilderApp: 'https://email-builder-prod.web.app',
    emailHomeAppUrl: 'https://email-home-prod.leadconnectorhq.com',
    emailPreviewAppUrl: 'https://email-preview-prod.leadconnectorhq.com',
    formBetaPreviewUrl: 'https://beta-widget.leadconnectorhq.com',
    formBuilderAppURL: 'https://leadgen-apps-form-survey-builder.leadconnectorhq.com',
    funnelBetaPreviewUrl: 'https://beta-widget.leadconnectorhq.com',
    funnelBuilderAppURL: 'https://page-builder.leadconnectorhq.com',
    isvAppUrl: 'https://ghl-isv-app-prod.leadconnectorhq.com',
    mobileAppCustomiserAppUrl: 'https://mobile-whitelabel-customizer.leadconnectorhq.com',
    newEmailHomeBetaUrl: 'https://email-home-beta.leadconnectorhq.com',
    newEmailPreviewBetaUrl: 'https://email-preview-prod.leadconnectorhq.com',
    newOnboardingFrontend: 'https://onboarding.gohighlevel.com',
    paymentsAppUrl: 'https://app-payments.leadconnectorhq.com',
    proposalBuilderAppUrl: 'https://leadgen-apps-proposal-builder.leadconnectorhq.com',
    proposalTemplateBuilderAppUrl: 'https://leadgen-apps-template-builder.leadconnectorhq.com',
    proposalBuilderPreviewUrl: 'https://sendlink.co',
    prospect: {
      frontendUrl: 'https://prod.analyzemy.business',
    },
    settingsAppUrl: 'https://client-app-crm-settings.leadconnectorhq.com',
    supportPortalUrl: 'https://support.leadconnectorhq.com/',
    surveyBetaPreviewUrl: 'https://beta-widget.leadconnectorhq.com',
    templateLibraryAppUrl: 'https://prod-template-library.leadconnectorhq.com',
    widgetUrl: 'https://api.leadconnectorhq.com',
    workflowAppURL: 'https://client-app-automation-workflows.leadconnectorhq.com',
  },
}

const iframeApps = config[override ? 'production' : (process.env.NODE_ENV as keyof typeof config)]

if (process.env.NODE_ENV === 'development' && !override) {
  //  iframeApps.affiliateManagerAppUrl= 'http://localhost:3020'
  iframeApps.blogsAppUrl = 'http://localhost:3030'
  //  iframeApps.builderPreviewUrl= 'http://localhost:3344'
  //  iframeApps.calendarAppURL= 'https://staging-client-app-calendars.web.app'
  //  iframeApps.calendarBetaPreviewUrl= 'http://localhost:3344'
  //  iframeApps.conversationsAppUrl= 'http://localhost:3031'
  //  iframeApps.crmLocationAppURL= 'https://staging-crm-apps-rollup.leadconnectorhq.com' //'http://localhost:3030'//
  //  iframeApps.crmOpportunitiesAppURL= 'http://localhost:3031'
  //  iframeApps.emailBuilderApp= 'http://localhost:3002'
  //  iframeApps.emailHomeAppUrl= 'http://localhost:3003'
  //  iframeApps.emailPreviewAppUrl= 'http://localhost:3001'
  //  iframeApps.formBetaPreviewUrl= 'http://localhost:3344'
  //  iframeApps.formBuilderAppURL= 'http://localhost:3032'
  //  iframeApps.funnelBetaPreviewUrl= 'http://localhost:3344'
  //  iframeApps.funnelBuilderAppURL= 'http://localhost:3333'
  //  iframeApps.isvAppUrl= 'http://localhost:3031'
  //  iframeApps.mobileAppCustomiserAppUrl= 'http://localhost:39430'
  //  iframeApps.newEmailHomeBetaUrl= 'https://hl-email-home--anz-staging-wapmruc1.web.app'
  //  iframeApps.newEmailPreviewBetaUrl= 'https://hl-email-preview--anz-staging-qj636k3k.web.app'
  //  iframeApps.newOnboardingFrontend= 'http://localhost:8081'
  //  iframeApps.paymentsAppUrl= 'http://localhost:3040'
  //  iframeApps.proposalBuilderAppUrl= 'http://localhost:3040'
  //  iframeApps.proposalTemplateBuilderAppUrl= 'http://localhost:3042'
  //  iframeApps.prospect = {
  //   frontendUrl: 'http://localhost:3030'
  //  },
  //  iframeApps.settingsAppUrl= 'https://staging-client-app-crm-settings.web.app'
  //  iframeApps.settingsAppUrl= 'http://localhost:3031'
  //  iframeApps.socialMediaPlannerAppUrl= 'http://localhost:3041'
  //  iframeApps.supportPortalUrl= 'https://ghl-support-portal.web.app/'
  //  iframeApps.surveyBetaPreviewUrl= 'http://localhost:3344'
  //  iframeApps.templateLibraryAppUrl= 'http://localhost:8081'
  //  iframeApps.widgetUrl= 'https://funnel-preview-dot-highlevel-staging.uc.r.appspot.com'
  //  iframeApps.workflowAppURL= 'http://localhost:3002'
}

if (process.env.NODE_ENV === 'development' && !override) {
  switch (process.env.VUE_APP_DEV_TEAM) {
    case 'payments':
      iframeApps.paymentsAppUrl = 'http://localhost:3040'
      iframeApps.blogsAppUrl = 'http://localhost:5092'
      break
    case 'workflows':
      iframeApps.workflowAppURL = 'http://localhost:3002'
      break
  }
}

if (process.env.NODE_ENV === 'development' && !override) {
  //   affiliateManagerAppUrl: 'http://localhost:3020',
  //   blogsAppUrl: 'http://localhost:3030',
  //   builderPreviewUrl: 'http://localhost:3344',
  //   calendarAppURL: 'https://staging-client-app-calendars.web.app',
  //   calendarBetaPreviewUrl: 'http://localhost:3344',
  //   conversationsAppUrl: 'http://localhost:3031',
  //   crmLocationAppURL: 'https://staging-crm-apps-rollup.leadconnectorhq.com', //'http://localhost:3030',//
  //   crmOpportunitiesAppURL: 'http://localhost:3031',
  //   emailBuilderApp: 'http://localhost:3002',
  //   emailHomeAppUrl: 'http://localhost:3003',
  //   emailPreviewAppUrl: 'http://localhost:3001',
  //   formBetaPreviewUrl: 'http://localhost:3344',
  //   formBuilderAppURL: 'http://localhost:3032',
  //   funnelBetaPreviewUrl: 'http://localhost:3344',
  //   funnelBuilderAppURL: 'http://localhost:3333',
  //   isvAppUrl: 'http://localhost:3031',
  //   mobileAppCustomiserAppUrl: 'http://localhost:39430',
  //   newEmailHomeBetaUrl: 'https://hl-email-home--anz-staging-wapmruc1.web.app',
  //   newEmailPreviewBetaUrl: 'https://hl-email-preview--anz-staging-qj636k3k.web.app',
  //   newOnboardingFrontend: 'http://localhost:8081',
  //   paymentsAppUrl: 'http://localhost:3040',
  //   proposalBuilderAppUrl: 'http://localhost:3040',
  //   proposalTemplateBuilderAppUrl: 'http://localhost:3042',
  //   prospect: {
  //     frontendUrl: 'http://localhost:3030',
  //   },
  //   settingsAppUrl: 'https://staging-client-app-crm-settings.web.app',
  //   supportPortalUrl: 'https://ghl-support-portal.web.app/',
  //   surveyBetaPreviewUrl: 'http://localhost:3344',
  //   templateLibraryAppUrl: 'http://localhost:8081',
  //   widgetUrl: 'https://funnel-preview-dot-highlevel-staging.uc.r.appspot.com',
  //   workflowAppURL: 'http://localhost:3002',
}

export default iframeApps
